export interface Message<T> {
  payload: T
  correlationId: string
  messageId: string
}
